import React from "react";

export const Panel = ({ title, code, action, children, className = "", testid }) => (
  <div
    className={`sov-panel sov-corners ${className}`}
    data-testid={testid}
  >
    <span className="corner tl" />
    <span className="corner tr" />
    <span className="corner bl" />
    <span className="corner br" />
    {(title || action) && (
      <div className="flex items-center justify-between px-5 py-3 border-b border-[color:var(--gold-line)]">
        <div className="flex items-center gap-3">
          {code && (
            <span className="font-mono text-[9px] tracking-[0.28em] text-gold-300 uppercase">
              {code}
            </span>
          )}
          {title && (
            <h3 className="font-display text-[12.5px] tracking-[0.22em] text-gold-100 uppercase">
              {title}
            </h3>
          )}
        </div>
        {action}
      </div>
    )}
    <div className="relative z-[2]">{children}</div>
  </div>
);

export const SevPill = ({ severity }) => (
  <span className={`sev-pill sev-${severity}`} data-testid={`sev-pill-${severity}`}>
    {severity}
  </span>
);

export const StatusPill = ({ status }) => (
  <span className={`status-pill status-${status}`} data-testid={`status-pill-${status}`}>
    {status}
  </span>
);

export const Kpi = ({ label, value, sub, accent, testid }) => (
  <div className="kpi sov-corners" data-testid={testid}>
    <span className="corner tl" />
    <span className="corner tr" />
    <span className="corner bl" />
    <span className="corner br" />
    <div className="kpi-label">{label}</div>
    <div className={`kpi-value ${accent ? "gold-glow" : ""}`}>{value}</div>
    {sub && <div className="kpi-sub">{sub}</div>}
  </div>
);

export const SectionTitle = ({ children, sub }) => (
  <div className="mb-6">
    <div className="sov-divider mb-2">
      <span className="sov-sigil" style={{ width: 14, height: 14 }} />
      <h2 className="font-display text-[20px] tracking-[0.32em] text-gold-100">{children}</h2>
      <span className="font-mono text-[10px] tracking-[0.22em] text-ivory-3 uppercase">
        {sub}
      </span>
    </div>
  </div>
);

export const TimeAgo = ({ iso }) => {
  if (!iso) return <span className="text-ivory-3">—</span>;
  const diff = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  let label;
  if (diff < 60) label = `${diff}s ago`;
  else if (diff < 3600) label = `${Math.floor(diff / 60)}m ago`;
  else if (diff < 86400) label = `${Math.floor(diff / 3600)}h ago`;
  else label = `${Math.floor(diff / 86400)}d ago`;
  return <span className="font-mono text-[11px] text-ivory-2">{label}</span>;
};
